import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosProtected from "../config/baseWithToken";
import { toast } from "react-toastify";

export const createReferral = createAsyncThunk(
  "admin/referral/add",
  async (referralInfo, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post(
        `/admin/referrals`,
        referralInfo
      );
      toast.success(data.message);
      
      dispatch(getReferrals());
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);
export const getReferrals = createAsyncThunk(
  "admin/referral/get",
  async (_referralInfo, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.get(
        `/admin/referrals`,
      );
      return data?.data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);
export const getReferralsUsers = createAsyncThunk(
  "admin/referral/get/referral-users",
  async (_referralInfo, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.get(
        `/admin/referrals/referral-users`,
      );
      return data?.data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const updateReferral = createAsyncThunk(
    "admin/referral/update",
    async (referralInfo, { dispatch, rejectWithValue }) => {
      try {
        let { data } = await axiosProtected.put(
          `/admin/referrals/${referralInfo.referralId}`,
          referralInfo.updateDetails
        );
        toast.success(data.message);
        dispatch(getReferrals());
        return data;
      } catch (e) {
        toast.error(e.response.data.message);
        rejectWithValue(e.response.data);
      }
    }
  );

export const deleteReferral = createAsyncThunk(
    "admin/referral/delete",
    async (referralInfo, { dispatch, rejectWithValue }) => {
      try {
        let { data } = await axiosProtected.delete(
          `/admin/referrals/${referralInfo.referralId}`
        );
        toast.success(data.message);
        dispatch(getReferrals());
        return data;
      } catch (e) {
        toast.error(e.response.data.message);
        rejectWithValue(e.response.data);
      }
    }
  );